import React, { useState } from "react";
import { useForm } from "react-hook-form";
import RadioGroup, { RadioGroupController, RadioOption } from "./RadioGroup";

// Mirrors the customer-type selector from the design reference.
const CUSTOMER_TYPE_OPTIONS: RadioOption[] = [
	{ value: "company", label: "Företag" },
	{ value: "concern", label: "Företag i koncern" },
	{ value: "private", label: "Privatperson" },
];

const PLAN_OPTIONS: RadioOption[] = [
	{ value: "basic", label: "Basic", hint: "For small teams getting started" },
	{ value: "pro", label: "Pro", hint: "Advanced scheduling and reports" },
	{ value: "enterprise", label: "Enterprise", hint: "SSO, audit log and SLA", disabled: true },
];

const RadioGroupExample: React.FC = () => {
	const [customerType, setCustomerType] = useState("concern");
	const [plan, setPlan] = useState("basic");

	const { control, handleSubmit } = useForm({
		defaultValues: { customerType: "company" },
	});

	const onSubmit = (data: any) => alert(JSON.stringify(data, null, 2));

	return (
		<div className="max-w-xl space-y-8 p-6">
			<h3 className="text-lg font-semibold">RadioGroup Component Examples</h3>

			{/* Horizontal — the design reference */}
			<div>
				<h4 className="text-md mb-2 font-medium">Horizontal (default)</h4>
				<RadioGroup
					options={CUSTOMER_TYPE_OPTIONS}
					value={customerType}
					onChange={setCustomerType}
					skipTranslation
				/>
				<p className="mt-2 text-sm text-gray-600">Selected: {customerType}</p>
			</div>

			{/* With group label + mandatory */}
			<div>
				<h4 className="text-md mb-2 font-medium">With label + mandatory</h4>
				<RadioGroup
					label="Kundtyp"
					mandatory
					options={CUSTOMER_TYPE_OPTIONS}
					value={customerType}
					onChange={setCustomerType}
					skipTranslation
				/>
			</div>

			{/* Vertical with hints + a disabled option */}
			<div>
				<h4 className="text-md mb-2 font-medium">Vertical with hints &amp; disabled option</h4>
				<RadioGroup
					orientation="vertical"
					options={PLAN_OPTIONS}
					value={plan}
					onChange={setPlan}
					skipTranslation
				/>
				<p className="mt-2 text-sm text-gray-600">Selected: {plan}</p>
			</div>

			{/* Error state */}
			<div>
				<h4 className="text-md mb-2 font-medium">Error state</h4>
				<RadioGroup
					label="Kundtyp"
					mandatory
					options={CUSTOMER_TYPE_OPTIONS}
					value=""
					onChange={() => {}}
					errors="Detta fält är obligatoriskt"
					skipTranslation
				/>
			</div>

			{/* Disabled whole group */}
			<div>
				<h4 className="text-md mb-2 font-medium">Disabled group</h4>
				<RadioGroup
					options={CUSTOMER_TYPE_OPTIONS}
					value="company"
					onChange={() => {}}
					disabled
					skipTranslation
				/>
			</div>

			{/* React Hook Form integration */}
			<div>
				<h4 className="text-md mb-4 font-medium">React Hook Form Integration</h4>
				<form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
					<RadioGroupController
						control={control}
						name="customerType"
						label="Kundtyp"
						options={CUSTOMER_TYPE_OPTIONS}
						mandatory
						skipTranslation
					/>
					<button
						type="submit"
						className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
					>
						Submit Form
					</button>
				</form>
			</div>
		</div>
	);
};

export default RadioGroupExample;
